import { getStaticPathForModels } from '@cinch-nx/landing-feature-car-reviews-hub'

export const getStaticPaths = getStaticPathForModels({ requiresPage: false })
export {
  V2GetStaticProps as getStaticProps,
  CarReviewsHubFeature as default,
} from '@cinch-nx/landing-feature-car-reviews-hub'
